import React from 'react';
import StringFieldProto from './string-proto.jsx';


export default function renderStringInList(id, props) {
    return <StringFieldProto renderMode="list" id={id} {...props} />;
}